import { render } from "./TrainingDetailsContent.vue?vue&type=template&id=672843ea"
import script from "./TrainingDetailsContent.vue?vue&type=script&lang=js"
export * from "./TrainingDetailsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__